import { Reference } from '../model/Reference';

// TODO: Doplnit 1 slovenskou referenci (FN Trnava) — text citace dodá byznys,
// bez podkladu nekódovat.
export const references: Reference[] = [
  {
    key: 'gucky',
    name: 'RNDr. Tomáš Gucký, Ph.D.',
    photo: 'gucky.jpg',
  },
  {
    key: 'jamrikova',
    name: 'Vladislava Jamriková',
    photo: 'jamrikova.jpg',
  },
  {
    key: 'troszok',
    name: 'Ing. Aleš Troszok, Ph.D.',
    photo: 'troszok.jpg',
  },
  {
    key: 'kamenikova',
    name: 'Ing. Alena Kameníková',
    photo: 'kamenikova.jpg',
  },
  {
    key: 'nedvedova',
    name: 'RNDr. Iveta Nedvědová, Ph.D.',
    photo: 'nedvedova.jpg',
  },
  {
    key: 'senft',
    name: 'Ing. Václav Senft',
    photo: 'senft.jpg',
  },
  {
    key: 'korabova',
    name: 'RNDr. Dagmar Korábová',
    photo: 'korabova.jpg',
  },
  {
    key: 'chobolova',
    name: 'PhDr. Nela Chobolová, MBA',
    photo: 'chobolova.jpg',
  },
  {
    key: 'bartalova',
    name: 'Ing. Monika Bartalová',
    photo: 'bartalova.jpg',
  },
  {
    key: 'novackova',
    name: 'Mgr. Karolína Nováčková',
    photo: 'novackova.jpg',
  },
  {
    key: 'venhacova',
    name: 'Ing. Jana Venháčová',
    photo: 'venhacova.jpg',
  },
  {
    key: 'borek',
    name: 'Milan Bořek',
    photo: 'borek.jpg',
  },
];

/** Testimonials about the consulting services, shown on the consulting page. */
export const consultingReferences: Reference[] = [
  {
    key: 'stejskal',
    name: 'prof. MUDr. David Stejskal, Ph.D., MBA, EuSpLM',
    // A stand-in emblem of the institute until a portrait is available.
    photo: 'ulm-fno.svg',
  },
  {
    key: 'korabova',
    name: 'RNDr. Dagmar Korábová',
    photo: 'korabova.jpg',
  },
  {
    key: 'sipova',
    name: 'MUDr. Veronika Šípová',
    photo: 'sipova.jpg',
  },
  {
    key: 'pannova',
    name: 'MUDr. Jana Pannová',
    // A stand-in emblem of the practice until a portrait is available.
    photo: 'gynekologie-nj.svg',
  },
];
